import SkapaElement from '@ingka/skapa-webc-element';
import { html } from '@ingka/webc-tools';
// @ts-ignore
const styles = ':host{display:flex;height:.3125rem;margin-bottom:var(--skapa-loader-message-margin,0);position:relative;width:100%}label{clip:rect(1px,1px,1px,1px);height:1px;margin:-1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}progress{-webkit-appearance:none;appearance:none;background:rgb(var(--colour-neutral-2,245,245,245));border:0;border-radius:.375rem;height:100%;width:100%}progress::-webkit-progress-bar{background:rgb(var(--colour-neutral-2,245,245,245));border-radius:.375rem}progress::-moz-progress-bar{background:rgb(var(--colour-semantic-informative,0,88,163));border-radius:.375rem}progress::-webkit-progress-value{background:rgb(var(--colour-semantic-informative,0,88,163));border-radius:.375rem}@media (forced-colors:active){progress{appearance:revert;background:revert;border:revert;border-radius:revert;height:revert}}';
let template;
function getTemplate() {
    if (!template) {
        template = document.createElement('template');
        template.innerHTML = html `
    <style>${styles}</style>
    <label for="progress-bar"><slot></slot></label>
    <progress id="progress-bar" value="0" max="100"></progress>
    `;
    }
    return template;
}
const properties = ['value', 'max'];
export class LoadingLinear extends SkapaElement {
    constructor() {
        super();
        this.gatherProperties([...properties], this);
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.append(getTemplate().content.cloneNode(true));
        this.progressElement = shadow.querySelector('progress');
    }
    attributeChangedCallback(name, old, _new) {
        this.progressElement[name] = Number(_new);
    }
    get value() {
        return Number(this.getAttribute('value')) || 0;
    }
    set value(val) {
        this.setAttribute('value', val.toString());
    }
    get max() {
        return Number(this.getAttribute('max')) || 100;
    }
    set max(val) {
        this.setAttribute('max', val.toString());
    }
}
LoadingLinear.observedAttributes = properties;
